import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import {
  faBolt,
  faGavel,
  faRightToBracket,
} from '@fortawesome/pro-solid-svg-icons'

import type { AuctionActionCta } from './useAuctionActionForm'

/**
 * Which states require an amount input.
 *
 * The `narrow` panel opens the InlineBidOverlay for these states.
 */
export const CTA_TAKES_AN_AMOUNT: Record<AuctionActionCta, boolean> = {
  bidNow: true,
  buyNow: false,
  raiseBid: true,
  signInToBid: false,
  signInToBuy: false,
}

export const CTA_ICONS: Record<AuctionActionCta, IconDefinition> = {
  bidNow: faGavel,
  buyNow: faBolt,
  raiseBid: faGavel,
  signInToBid: faRightToBracket,
  signInToBuy: faRightToBracket,
}
